/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from "three";
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";

type GLTFResult = GLTF & {
  nodes: {
    U002: THREE.Mesh;
  };
  materials: {
    ["U.001"]: THREE.MeshStandardMaterial;
  };
};

export function LetterUModel(
  props: React.ComponentProps<"group"> & {
    color?: string;
    metalness?: number;
    roughness?: number;
  }
) {
  const { color, metalness, roughness, ...groupProps } = props;
  const { nodes, materials } = useGLTF(
    "/models/U.glb"
  ) as unknown as GLTFResult;
  return (
    <group {...groupProps} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.U002.geometry}
        position={[0.881, -0.5, 0.3]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[100.439, 140.439, 100.439]}
      >
        <meshStandardMaterial
          color={color || materials["U.001"].color}
          metalness={
            metalness !== undefined ? metalness : materials["U.001"].metalness
          }
          roughness={
            roughness !== undefined ? roughness : materials["U.001"].roughness
          }
        />
      </mesh>
    </group>
  );
}

useGLTF.preload("/models/U.glb");
